import { IProperty, IPropertyRequest, updateByIdRequest } from 'src/ts/interfaces';
import api from '../api';

export const updatePropertyLogo = async (
  property: IProperty,
  propertyResponse: updateByIdRequest<IPropertyRequest>
) => {
  try {
    if (!propertyResponse?.request.property.logo) {
      throw new Error('Could not get logo for the property');
    }
    if (!((propertyResponse?.request.property.logo as any) instanceof File)) {
      return;
    }
    const getPropertyURLResponse = await api.getPropertyLogoURL(property?.id || '');
    if (!getPropertyURLResponse) {
      throw new Error('Could not get the presigned url for the property');
    }
    const { url, fields, method } = getPropertyURLResponse.presigned_url || {};
    if (!url || !fields || !method) {
      throw new Error('Could not get url, fields, metadata or method');
    }
    await api.savePropertyFile({
      method,
      url,
      fields,
      type: 'image/png',
      file: propertyResponse?.request.property.logo as unknown as File
    });
    await api.setPropertyLogoURL(property?.id || '');
    return await api.getById(property?.id || '');
  } catch (error: any) {
    console.error(error?.message);
  }
};
